import axios from 'axios';

// Налаштування базового URL для всіх запитів
// axios.defaults.baseURL = 'http://localhost:3000/api/';
axios.defaults.baseURL = 'https://api.piramidabus-service.com/api/';

// Об'єкт для управління токеном авторизації
export const authToken = {
  set(token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  },
  unset() {
    axios.defaults.headers.common.Authorization = '';
  },
};

// 🔥 Interceptor для 401
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      authToken.unset();

      // за бажанням — чистимо localStorage
      localStorage.removeItem('persist:auth');

      // редірект на логін
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);
